import { ControlledSelect, Select } from 'shared/form/components/Select';
import { SelectOption } from 'shared/form/models/SelectOption';
import { ReportFormat } from 'core/services/useCoreService';
import { FormInputWithValidationProps } from 'shared/form/models/FormInputWithValidation';

interface FormatSelectorProps {
  value: SelectOption<ReportFormat> | null;
  onChange: (option: SelectOption<ReportFormat>) => void;
}

const FORMAT_OPTIONS: SelectOption<ReportFormat>[] = [
  { value: 'PDF', label: 'PDF' },
  { value: 'XLS', label: 'XLS' },
];

export const FormatSelector = ({ value, onChange }: FormatSelectorProps) => {
  return (
    <Select
      options={FORMAT_OPTIONS}
      label="Formato"
      name="formato"
      value={value}
      placeholder="Seleccione un formato"
      onChange={onChange}

    />
  );
};

export const ControlledFormatSelector = (props: FormInputWithValidationProps) => {
  return (
    <ControlledSelect
      {...props}
      label="Formato"
      options={FORMAT_OPTIONS}
      placeholder="Seleccione un formato"
    />
  );
};